module.exports = __webpack_public_path__ + "static/media/homeowners.99e82fbe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/homeowners.svg
// module id = 339
// module chunks = 0